export const environment = {
  production: true,
  API_PRICE: 'https://spw.app.foursys.com/pricing/api',
  gestaoId: 1,
  debugging: false
};
